import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import routes from './routes';
import store from '@/store';

const router = new VueRouter({
  routes,

  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 };
  // }
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (await store.dispatch('auth/checkLogin')) {
      if (!store.state.user.user) {
        await store.dispatch('user/getUserInfo', store.state.auth.userId);
      }
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

export default router;
